import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  createValidationAssignmentsToMachine,
  deleteValidationAssignmentsToMachine,
  getValidationAssignmentsToMachine,
  updateValidationAssignmentsToMachine,
} from "data/server_apis/commodityService";

const validationAssignmentsToMachineAdapter = createEntityAdapter({
  selectId: (validationAssignment) => validationAssignment.id,
});

export const getValidationAssignmentsToMachinesThunk = createAsyncThunk(
  "ValidationAssignmentsToMachines/get",
  async (id, { rejectWithValue }) => {
    try {
      return (await getValidationAssignmentsToMachine(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createValidationAssignmentsToMachineThunk = createAsyncThunk(
  "ValidationAssignmentsToMachines/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createValidationAssignmentsToMachine(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateValidationAssignmentsToMachineThunk = createAsyncThunk(
  "ValidationAssignmentsToMachine/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateValidationAssignmentsToMachine(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const deleteValidationAssignmentsToMachineThunk = createAsyncThunk(
  "ValidationAssignmentsToMachine/delete",
  async (id, { rejectWithValue }) => {
    try {
      return (await deleteValidationAssignmentsToMachine(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const validationAssignmentsToMachinesSlice = createSlice({
  name: "validationAssignmentsToMachine",
  initialState: validationAssignmentsToMachineAdapter.getInitialState({
    status: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        getValidationAssignmentsToMachinesThunk.pending,
        (state, action) => {
          state.status = { loading: "get", id: action.meta.arg };
        }
      )
      .addCase(
        getValidationAssignmentsToMachinesThunk.rejected,
        (state, action) => {
          state.status = {
            error: "get",
            errorMessage: action.payload?.message,
             id: action.meta.arg 
          };
        }
      )
      .addCase(
        getValidationAssignmentsToMachinesThunk.fulfilled,
        (state, action) => {
          state.status = { success: "get",id: action.meta.arg  };
          validationAssignmentsToMachineAdapter.setAll(state, action.payload);
        }
      );

    builder
      .addCase(
        createValidationAssignmentsToMachineThunk.pending,
        (state, action) => {
          state.status = { loading: "create" };
        }
      )
      .addCase(
        createValidationAssignmentsToMachineThunk.rejected,
        (state, action) => {
          state.status = {
            error: "create",
            errorMessage: action.payload?.message,
          };
        }
      )
      .addCase(
        createValidationAssignmentsToMachineThunk.fulfilled,
        (state, action) => {
          state.status = { success: "create" };
          validationAssignmentsToMachineAdapter.addOne(state, action.payload);
        }
      );

    builder
      .addCase(
        updateValidationAssignmentsToMachineThunk.pending,
        (state, action) => {
          state.status = { loading: "update", id: action.meta.arg.id };
        }
      )
      .addCase(
        updateValidationAssignmentsToMachineThunk.rejected,
        (state, action) => {
          state.status = {
            error: "update",
            errorMessage: action.payload?.message,
            id: action.meta.arg.id,
          };
        }
      )
      .addCase(
        updateValidationAssignmentsToMachineThunk.fulfilled,
        (state, action) => {
          state.status = { success: "update" };
          validationAssignmentsToMachineAdapter.updateOne(state, {
            id: action.meta.arg.id,
            changes: action.payload,
          });
        }
      );

    builder
      .addCase(
        deleteValidationAssignmentsToMachineThunk.pending,
        (state, action) => {
          state.status = { loading: "delete", id: action.meta.arg };
        }
      )
      .addCase(
        deleteValidationAssignmentsToMachineThunk.rejected,
        (state, action) => {
          state.status = {
            id: action.meta.arg,
            error: "delete",
            errorMessage: action.payload?.message,
          };
        }
      )
      .addCase(
        deleteValidationAssignmentsToMachineThunk.fulfilled,
        (state, action) => {
          state.status = { success: "delete", id: action.meta.arg };
          validationAssignmentsToMachineAdapter.removeOne(
            state,
            action.meta.arg
          );
        }
      );
  },
});
export const validationAssignmentsToMachineSelector =
  validationAssignmentsToMachineAdapter.getSelectors(
    (state) => state.validationAssignments
  );

export const {} = validationAssignmentsToMachinesSlice.actions;

export default validationAssignmentsToMachinesSlice.reducer;
